<div class="header-name" (click)="onHeaderClick($event)">{{ params.displayName }}</div>
